<div class="white-box main-black mt-4 p-4 border-radius" *ngIf="macAddress">
	<app-attachments
		[title]="'attachments.device' | translate"
		[source]="source"
		[sourceId]="macAddress"
	></app-attachments>
</div>